module.exports = __webpack_public_path__ + "img/about-promo-1.6f225370.png";